import type { ReactNode } from 'react'
import { Breadcrumbs, type Crumb } from './Breadcrumbs'

/*
  PageHeader — encabezado estándar de página: ruta (breadcrumbs) a la izquierda
  y zona de acciones a la derecha. Envuelve `.page-header` / `.page-subtitle` /
  `.page-actions` de index.css.

  Regla de UI: las páginas se identifican por su **breadcrumb**, no por un
  título grande. `title` queda solo para pantallas legadas todavía sin migrar;
  toda página nueva pasa `breadcrumbs`.
*/
interface PageHeaderProps {
  /** Ruta de la página. Es la forma preferida de encabezar una pantalla. */
  breadcrumbs?: Crumb[]
  /** Contador auxiliar al lado de la ruta (ej. "23 pagos", "8 de 40"). */
  meta?: ReactNode
  /** Legado: título grande. No usar en páginas nuevas. */
  title?: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
}

export function PageHeader({ breadcrumbs, meta, title, subtitle, actions }: PageHeaderProps) {
  return (
    <div className={`page-header${breadcrumbs ? ' page-header--crumbs' : ''}`}>
      <div>
        {breadcrumbs
          ? <Breadcrumbs items={breadcrumbs} meta={meta} />
          : <h1>{title}</h1>}
        {subtitle && <p className="page-subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </div>
  )
}
